// 3D BOOK

// LottieInteractivity.create({
//     player: '#dearLoveBook',
//     mode: 'cursor',
//     actions: [
//         {
//             position: { x: [0, 1], y: [-1, 2] },
//             type: 'seek',
//             frames: [0, 100],
//         }
//     ]
// });

// FALLING ROSES DESKTOP

var falling = true;

var total_left = 10;
var total_right = 10;
var containerLeft = document.getElementById("rosesFallingLeft");
var containerRight = document.getElementById("rosesFallingRight")
var w = document.getElementById("rosesFallingLeft").offsetWidth;
var h = document.getElementById("rosesFallingRight").offsetHeight;

// FALLING LEFT
for (i=0; i<total_left; i++){ 
   var rose_div = document.createElement('div');
   rose_div.setAttribute('id', 'rose_left_'+i);
   const sizes = [60, 100, 60, 100, 140, 180];
   const z = [0, 0, 0, 0, 0, 0];
   const random = Math.floor(Math.random() * sizes.length);
   rose_div.style.width = sizes[random] + 'px';
   rose_div.style.height = sizes[random] + 'px';
   rose_div.style.zIndex = z[random];

   TweenLite.set(rose_div,{attr:{class:'roses'},x:R(0,w),y:R(-200,-150),z:R(-200,200)});
   containerLeft.appendChild(rose_div);
   animmLeft(rose_div, i);
}

// FALLING RIGHT
for (i=0; i<total_right; i++){ 
   var rose_div = document.createElement('div');
   rose_div.setAttribute('id', 'rose_right_'+i);
   const sizes = [60, 100, 60, 100, 140, 180];
   const z = [0, 0, 0, 0, 0, 0];
   const random = Math.floor(Math.random() * sizes.length);
   rose_div.style.width = sizes[random] + 'px';
   rose_div.style.height = sizes[random] + 'px';
   rose_div.style.zIndex = z[random];

   TweenLite.set(rose_div,{attr:{class:'roses'},x:R(0,w),y:R(-200,-150),z:R(-200,200)});
   containerRight.appendChild(rose_div);
   animmRight(rose_div);
}
 
function animmLeft(element, identifier){ 
	var verticalTime = R(6,15);
	TweenMax.to(element,verticalTime,{y:h+100,ease:Linear.easeNone,repeat:-1,delay:-15});
    TweenMax.to(element,R(6,10),{x:'-=100',rotationZ:R(-90,90),repeat:-1,yoyo:true,ease:Sine.easeInOut});
    TweenMax.to(element,R(4,10),{rotationX:R(-45,45),rotationY:R(0,0),repeat:-1,yoyo:true,ease:Sine.easeInOut,delay:-5});
};

function animmRight(element){   
   TweenMax.to(element,R(6,15),{y:h+100,ease:Linear.easeNone,repeat:-1,delay:-15});
   TweenMax.to(element,R(6,10),{x:'+=100',rotationZ:R(-90,90),repeat:-1,yoyo:true,ease:Sine.easeInOut});
   TweenMax.to(element,R(4,10),{rotationX:R(-45,45),rotationY:R(0,0),repeat:-1,yoyo:true,ease:Sine.easeInOut,delay:-5});
};

function R(min,max) {return min+Math.random()*(max-min)};


// FALLING ROSES MOBILE

var falling_mobile = true;

var total_left_mobile = 10;
var total_right_mobile = 10;
var containerLeft_mobile = document.getElementById("rosesFallingLeft_mobile");
var containerRight_mobile = document.getElementById("rosesFallingRight_mobile")
var w_mobile = document.getElementById("rosesFallingLeft_mobile").offsetWidth;
var h_mobile = document.getElementById("rosesFallingRight_mobile").offsetHeight;

console.log('w_mobile = ' + w_mobile);

// FALLING LEFT
for (i=0; i<total_left_mobile; i++){ 
   var rose_div = document.createElement('div');
   rose_div.setAttribute('id', 'rose_left_mobile_'+i);
   const sizes = [60, 100, 60, 100, 140, 180];
   const z = [0, 0, 0, 0, 0, 0];
   const random = Math.floor(Math.random() * sizes.length);
   rose_div.style.width = sizes[random] + 'px';
   rose_div.style.height = sizes[random] + 'px';
   rose_div.style.zIndex = z[random];

   TweenLite.set(rose_div,{attr:{class:'roses'},x:RMobile(0,w_mobile),y:RMobile(-200,-150),z:RMobile(-200,200)});
   containerLeft_mobile.appendChild(rose_div);
   animmLeftMobile(rose_div, i);
}

// FALLING RIGHT
for (i=0; i<total_right_mobile; i++){ 
   var rose_div = document.createElement('div');
   rose_div.setAttribute('id', 'rose_right_mobile_'+i);
   const sizes = [60, 100, 60, 100, 140, 180];
   const z = [0, 0, 0, 0, 0, 0];
   const random = Math.floor(Math.random() * sizes.length);
   rose_div.style.width = sizes[random] + 'px';
   rose_div.style.height = sizes[random] + 'px';
   rose_div.style.zIndex = z[random];

   TweenLite.set(rose_div,{attr:{class:'roses'},x:RMobile(0,w_mobile),y:RMobile(-200,-150),z:RMobile(-200,200)});
   containerRight_mobile.appendChild(rose_div);
   animmRightMobile(rose_div);
}

function animmLeftMobile(element, identifier){ 
	var verticalTime = R(6,15);
	TweenMax.to(element,verticalTime,{y:h_mobile+100,ease:Linear.easeNone,repeat:-1,delay:-15});
    TweenMax.to(element,R(6,10),{x:'-=100',rotationZ:R(-90,90),repeat:-1,yoyo:true,ease:Sine.easeInOut});
    TweenMax.to(element,R(4,10),{rotationX:R(-45,45),rotationY:R(0,0),repeat:-1,yoyo:true,ease:Sine.easeInOut,delay:-5});
};

function animmRightMobile(element){   
   TweenMax.to(element,R(6,15),{y:h_mobile+100,ease:Linear.easeNone,repeat:-1,delay:-15});
   TweenMax.to(element,R(6,10),{x:'+=100',rotationZ:R(-90,90),repeat:-1,yoyo:true,ease:Sine.easeInOut});
   TweenMax.to(element,R(4,10),{rotationX:R(-45,45),rotationY:R(0,0),repeat:-1,yoyo:true,ease:Sine.easeInOut,delay:-5});
};

function RMobile(min,max) {return min+Math.random()*(max-min)};
 
